module.exports = __webpack_public_path__ + "img/ml_logo.a770d3c2.png";